<div
  class="application-banner-region__sr-only"
  data-testid="application-banner-polite-announcer"
  aria-live="polite"
  aria-atomic="true"
>
  {{ politeAnnouncement() }}
</div>
<div
  class="application-banner-region__sr-only"
  data-testid="application-banner-assertive-announcer"
  aria-live="assertive"
  aria-atomic="true"
>
  {{ assertiveAnnouncement() }}
</div>

<section
  *ngIf="banners().length > 0"
  class="application-banner-region"
  aria-labelledby="application-banner-region-title"
  data-testid="application-banner-region"
>
  <h2 id="application-banner-region-title" class="application-banner-region__sr-only">
    Application messages
  </h2>

  <article
    *ngFor="let banner of banners(); trackBy: trackBanner"
    class="application-banner"
    [attr.data-banner-id]="banner.id"
    [attr.data-severity]="banner.severity"
  >
    <i [class]="iconFor(banner.severity)" aria-hidden="true"></i>

    <div class="application-banner__content">
      <span class="application-banner-region__sr-only">
        {{ severityLabel(banner.severity) }}:
      </span>
      <strong>{{ banner.title }}</strong>
      <p>{{ banner.message }}</p>
    </div>

    <button
      *ngIf="banner.dismissible"
      type="button"
      class="application-banner__dismiss"
      [attr.aria-label]="'Dismiss ' + banner.title + ' message'"
      (click)="dismiss(banner.id)"
    >
      <i class="pi pi-times" aria-hidden="true"></i>
    </button>
  </article>
</section>
